import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ApplicationItemProps } from 'src/features/shared/ApplicationSearch/types.applicationSearch'
import { applicationSearch, applicationSearchAgain } from './application.actions'
import { SearchParams } from '@lk/api'

type InitialState = {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  data: {
    [key: string]: ApplicationItemProps[]
  }
  error: string | null
  previousSearchParams: {
    [key: string]: SearchParams
  }
}

const initialState: InitialState = {
  status: 'idle',
  data: {},
  error: null,
  previousSearchParams: {},
}

export const ApplicationSearchSlice = createSlice({
  name: 'applicationSearch',
  initialState,
  reducers: {
    destroyApplicationsData: (state, action) => {
      state.data[action.payload] = []
    },
  },
  extraReducers(builder) {
    builder.addCase(applicationSearch.pending, (state, action) => {
      state.status = 'loading'
      state.error = null
    })
    builder.addCase(applicationSearch.fulfilled, (state, action) => {
      state.status = 'loaded'
      if (action.payload.instanceName) {
        state.previousSearchParams[action.payload.instanceName] = action.meta.arg
        state.data[action.payload.instanceName] = action.payload.data
      }
    })
    builder.addCase(applicationSearch.rejected, (state, action) => {
      state.status = 'failed'
    })
    builder.addCase(applicationSearchAgain.pending, (state, action) => {
      state.status = 'loading'
      state.error = null
    })
    builder.addCase(applicationSearchAgain.fulfilled, (state, action) => {
      state.status = 'loaded'
      if (action.payload.instanceName) {
        state.data[action.payload.instanceName] = action.payload.data
      }
    })
    builder.addCase(applicationSearchAgain.rejected, (state, action) => {
      state.status = 'failed'
    })
  },
})

export const applicationSearchReducer = ApplicationSearchSlice.reducer

export const { destroyApplicationsData } = ApplicationSearchSlice.actions
